import {
  ArrowTrendingUpIcon,
  CircleStackIcon,
  ClockIcon,
  CloudArrowUpIcon,
  Cog8ToothIcon,
  DocumentArrowUpIcon,
  DocumentCurrencyRupeeIcon,
  HomeIcon,
  PhoneIcon,
  RectangleGroupIcon,
  UserGroupIcon,
  UsersIcon,
  MapPinIcon
} from '@heroicons/react/24/outline';
import Home from '../pages/admin/Home';
import Dashboard from '../pages/admin/dashboard/Dashboard';
import UploadFileSection from '../pages/admin/uploads/UploadFileSection';
import Extraction from '../pages/extraction/Extraction';
// import SourceIntelligence from '../pages/admin/SourceIntelligence';
// import SourceScreening from '../pages/admin/SourceScreening';
// import SourcePrioritization from '../pages/admin/SourcePrioritization';
// import ManageProjects from '../pages/admin/projects/ManageProjects';
// import ManagePermissions from '../pages/admin/permissions/ManagePermissions';
import ManageRolePermissions from '../pages/admin/roles/ManageRolePermissions';
import UploadHistory from '../pages/admin/uploads/history/UploadHistory';
import ReviewUpload from '../pages/admin/uploads/history/review/ReviewUpload';
import LeadSourcesPage from '../pages/admin/leadSources/Page';
import VendorsPage from '../pages/admin/vendors/Page';
import RolesPage from '../pages/admin/roles/Page';
import ChannelPartnersPage from '../pages/admin/channelPartners/Page';
import UsersPage from '../pages/admin/users/Page';
import UserAdd from '../pages/admin/users/Add';
import UserUpdate from '../pages/admin/users/Update';
import DataCategoriesPage from '../pages/admin/dataCategories/Page';
import { UsersProvider } from '../contexts/UserContext';
import PowerBIDashboard from '../pages/admin/powerbi/PowerBIDashboard';
import ViewData from '../pages/admin/uploads/history/detailview/ViewData';
// import ProfileExtraction from '../pages/admin/profileExtraction/ProfileExtraction';
import { UserRoundCog } from 'lucide-react';
import { BarsArrowDownIcon } from '@heroicons/react/24/solid';
import ExtractionsHistory from '../pages/extraction/history/Page';
import OutputMappingsPage from '../pages/extraction/view/OutputMappingsPage';
// import ViewExtractionPage from '../pages/extraction/view/ViewExtractionPage';
import ViewFullDataPage from '../pages/extraction/view/ViewFullDataPage';


export const sidebarMenuItems = [
  {
    name: 'Dashboards',
    Icon: RectangleGroupIcon,
    // module: "dashboards",
    type: "menu-group",
    children: [
      {
        name: "Home",
        heading: 'Home',
        component: <Dashboard />,
        Icon: HomeIcon,
        to: "/dashboard",
        type: "submenu",
        // module: "dashboards",
        // submodule: "upload_files"
      },
      {
        name: "Call Center",
        heading: 'Call Center Dashboard',
        component: <PowerBIDashboard />,
        Icon: PhoneIcon,
        to: "/dashboard/call-center",
        type: "submenu",
        module: "dashboards",
        permission: "dashboards.bi_callcenter"
      },
      {
        name: "Procured Data",
        heading: 'Procured Data Dashboard',
        component: <PowerBIDashboard />,
        Icon: DocumentCurrencyRupeeIcon,
        to: "/dashboard/procured-data",
        type: "submenu",
        module: "dashboards",
        permission: "dashboards.bi_procureddata"
      },
      {
        name: "ML Model",
        heading: 'ML Model Dashboard',
        component: <PowerBIDashboard />,
        Icon: ArrowTrendingUpIcon,
        to: "/dashboard/ml-model",
        type: "submenu",
        module: "dashboards",
        permission: "dashboards.bi_mlmodel"
      },
      {
        name: "Lead Journey",
        heading: 'Lead Journey Dashboard',
        component: <PowerBIDashboard />,
        Icon: MapPinIcon,
        to: "/dashboard/lead-journey",
        type: "submenu",
        module: "dashboards",
        permission: "dashboards.bi_leadjourney"
      },
      // CMS for dashboards from admin panel
      // {
      //   name: "Lead Journey",
      //   heading: 'Lead Journey Dashboard',
      //   component: <PowerBIDashboard />,
      //   Icon: ArrowTrendingUpIcon,
      //   to: "/dashboard/lead-journey",
      //   type: "submenu",
      //   module: "dashboards",
      //   submodule: "powerbi"
      // },
    ]
  },
  {
      name: 'Data Upload Portal',
      Icon: CloudArrowUpIcon,
      module: "upload",
      type: "menu-group",
      children: [
        {
          name: "Upload New",
          heading: 'Data Upload Portal',
          component: <UploadFileSection />,
          Icon: DocumentArrowUpIcon,
          to: "/upload-files",
          type: "submenu",
          module: "upload",
          submodule: "upload_files"
        },
        {
          name: "Upload History",
          heading: 'Data Upload Portal',
          component: <UploadHistory/>,
          Icon: ClockIcon,
          to: "/upload-history",
          type: "submenu",
          module: "upload",
          submodule: "history"
        },
        {
            name: "Manage",
            Icon: Cog8ToothIcon,
            type: "sub-group",
            module: "upload",
            children: [
              {
                name: 'Lead Sources',
                heading: 'Data Upload Portal',
                component: <LeadSourcesPage />,
                to: '/lead-sources',
                module: "leadSources",
                type: "sub-submenu",
              },
              {
                name: 'Data Categories',
                heading: 'Data Upload Portal',
                component: <DataCategoriesPage />,
                to: '/data-categories',
                module: "dataCategories",
                type: "sub-submenu",
              },
              {
                name: 'Vendors',
                heading: 'Data Upload Portal',
                component: <VendorsPage />,
                to: '/vendors',
                module: "vendors",
                type: "sub-submenu",
              },
              {
                name: 'Channel Partners',
                heading: 'Data Upload Portal',
                component: <ChannelPartnersPage />,
                to: '/channel-partners',
                module: "channelPartners",
                type: "sub-submenu",
              },
              // {
              //   name: 'Projects',
              //   component: <ManageProjects />,
              //   to: '/projects',
              //   module: "projects",
              //   type: "sub-submenu",
              // },
            ],
        },
    ],
  },
  {
    name: 'Profile Extraction Portal',
    Icon: CircleStackIcon,
    module: "extractions",
    type: "menu-group",
    children: [
      {
        name: "Extract New",
        heading: 'Profile Extraction',
        component: <Extraction />,
        Icon: BarsArrowDownIcon,
        to: "/extraction/new",
        type: "submenu",
        module: "extractions",
        submodule: "crud"
      },
      {
        name: "Extraction History",
        heading: 'Profile Extraction',
        component: <ExtractionsHistory />,
        Icon: ClockIcon,
        to: "/extraction/history",
        type: "submenu",
        module: "extractions",
        submodule: "list"
      }
    ]
  },
  // {
  //     name: 'Profile Extraction',
  //     component: <ProfileExtraction />,
  //     Icon: CircleStackIcon,
  //     to: '/profile-extraction',
  //     module: "data_extraction"
  // },
  {
    name: 'User Management',
    Icon: UserGroupIcon,
    children: [
      {
        name: 'Users',
        heading: 'User Management',
        component: <UsersPage />,
        Icon: UsersIcon,
        to: '/users',
        module: "users"
      },
      {
        name: 'Roles',
        heading: 'User Management',
        Icon: UserRoundCog,
        component: <RolesPage />,
        to: '/roles',
        module: "roles"
      },
      // {
      //   name: 'Permissions',
      //   component: <ManagePermissions />,
      //   to: '/permissions',
      //   module: "SYSADM"
      // },
    ],
},
  // {
  //   name: 'Source Intelligence',
  //   component: <SourceIntelligence />, 
  //   Icon: CpuChipIcon,
  //   to: '/source-intelligence',
  //   module: "source_intelligence"
  // },
  // {
  //     name: 'Source Screening',
  //     component: <SourceScreening />,
  //     Icon: PresentationChartLineIcon,
  //     to: '/source-screening',
  //     module: "source_screening"
  // },
  // {
  //     name: 'Source Prioritization',
  //     component: <SourcePrioritization />,
  //     Icon: RectangleStackIcon,
  //     to: '/source-prioritization',
  //     module: "source_prioritization"
  // }
];

const AddUser = () => (
  <UsersProvider>
    <UserAdd />
  </UsersProvider>
)

const UpdateUser = () => (
  <UsersProvider>
    <UserUpdate />
  </UsersProvider>
)

export const privatePages = [
  {
    name: 'Home',
    component: <Home />,
    to: '/home',
  },
  {
    name: 'Manage Role Permissions',
    component: <ManageRolePermissions />,
    to: '/roles/permissions/:roleKey',
  },
  {
    name: 'Add User',
    component: <AddUser />,
    to: '/users/add',
  },
  {
    name: 'Update User',
    component: <UpdateUser />,
    to: '/users/:key',
  },
  {
    name: 'Review Upload',
    component: <ReviewUpload />,
    to: '/review-upload/:key',
    module: "upload"
  },
  {
    name: 'Data Upload',
    component: <UploadFileSection />,
    to: '/upload-files/:key',
    module: "upload"
  },
  {
    name: 'View Data',
    component: <ViewData />,
    to: '/view-data/:key',
    module: "upload"
  },
  {
    name: 'Profile Extraction Portal',
    component: <Extraction />,
    to: '/extraction/:key',
    module: 'extractions',
    submodules: ['crud', 'view']
  },  
  {
    name: 'Profile Extraction Portal',
    component: <OutputMappingsPage />,
    to: '/extraction/view/:key',
    module: 'extractions',
    submodule: 'view'
  },
  {
    name: 'Profile Extraction Portal',
    component: <ViewFullDataPage />,
    to: '/extraction/view-full-data/:key/:dataGroup/:dataCategory',
    module: 'extractions',
    submodule: 'view'
  }
];

export const menuItems = [ ...sidebarMenuItems, ...privatePages ];
